module.exports = __webpack_public_path__ + "img/Product1.837068c1.svg";